export default __webpack_public_path__ + "static/media/coordinateSearchMarker.d111718c.svg";